import React, { useState, useEffect} from 'react';
import ImageButton from './imageButton';

const Chrono = ({duration, server_host, setDuration, initial_duration, is_owner=false, is_coach=false}) => {

    const [isRunning, setIsRunning] = useState(false);


    useEffect(() => {
        let interval;
    
        if (isRunning) {
          interval = setInterval(() => {
            setDuration(-1);
          }, 1000);
        }
    
        return () => clearInterval(interval);
      }, [isRunning, setDuration]);
    
      const startTimer = () => {
        setIsRunning(true);
      };
    
      const addTimer = () => {
        setDuration(duration + 60000);
      };

      const addTimer10 = () => {
        setDuration(duration + 600000);
      };
    
      const subTimer = () => {
        const d = duration - 60000; 
        if (d <= 0) {
          setIsRunning(false)
        }
        setDuration(Math.max(0, d))
      };

      const subTimer10 = () => {
        const d = duration - 600000; 
        if (d <= 0) {
          setIsRunning(false)
        }
        setDuration(Math.max(0, d))
      };
    
      const stopTimer = () => {
        setIsRunning(false);
      };
    
      const resetTimer = () => {
        setDuration(initial_duration[0]);
        setIsRunning(false);
      };
    



    if (! is_coach) {
        return
    } 
    const rtime = duration / 1000
    let protocol = process.env.REACT_APP_PROTOCOL
    if (protocol === undefined){
      protocol = "http"
    }
  const bipSound = new Audio(protocol + '://' + server_host + ':3050/sounds/sonar_bip.flac');
  bipSound.volume = 0.07; // Adjust the volume as desired
 

  function bip() {
      bipSound.play();
  }


    if (rtime > 0){
        const minutes = Math.floor(rtime  / 60);
        const seconds = rtime % 60;
    
        if ((minutes === 0 && seconds <= 5 && isRunning) || (isRunning && seconds === 0))  {
          bip()
        }
        return (
            <div flex='4'>
            {isRunning  ? (
                <ImageButton
                    url={`${protocol}://${server_host}:3050/images/stop-circle.svg`} size='tiny' onClick={stopTimer} title="stop" color='#FF5555'/>
            ) : (
                <ImageButton
                url={`${protocol}://${server_host}:3050/images/play-circle.svg`}  size='tiny' title="start" onClick={startTimer}/>
            )}
              <span className='chronoValue'>{minutes.toString().padStart(2, '0')}:
              {seconds.toString().padStart(2, '0')}</span>
               <ImageButton
                    url={`${protocol}://${server_host}:3050/images/plus-circle.svg`}  size='tiny' title="+ 10'" 
                onClick={addTimer10} />
                <ImageButton
                    url={`${protocol}://${server_host}:3050/images/plus.svg`}  title="+ 1'" size='tiny' 
                 onClick={addTimer}/>
                   <ImageButton
                    url={`${protocol}://${server_host}:3050/images/minus.svg`}  title="- 1'" size='tiny' 
                  onClick={subTimer}/>
                    <ImageButton
                    url={`${protocol}://${server_host}:3050/images/minus-circle.svg`}  title="- 10'" size='tiny' 
                   onClick={subTimer10}/>
                  {! is_owner ? (
                   <ImageButton
                   url={`${protocol}://${server_host}:3050/images/smile.svg`}  title="coach invité" size='tiny' />
                  ) : ( ' ')}
          </div>
        )
    } else {
        return (
            <div className="over" flex='4'>
                <ImageButton title='chrono'
                    url={`${protocol}://${server_host}:3050/images/clock.svg`}
                onClick={() => resetTimer(initial_duration)}/>
            </div>
        )
    }
}

export default Chrono;